import { TargetGroupSidebar } from "@/components/campaign/TargetGroupSidebar";
import { TargetGroupProvider } from "@/providers/TargetGroupProvider";
import { useConfigurationCounts } from "@/queries/configurations";
import { newCampaignStateAtom } from "@/services/new-campaign.service";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/_dashboard/campaigns/setup/define")({
  component: RouteComponent,
  loader: async () => {
    return {
      isBreadcrumbRoot: true,
      crumb: "Målgruppe",
      meta: {
        title: "Målgruppe",
      },
    };
  },
});

function RouteComponent() {
  const campaign = useAtomValue(newCampaignStateAtom);
  const { useStepper } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const stepper = useStepper();

  const { isLoading: isCountsLoading } = useConfigurationCounts({
    configurations: campaign.configurations,
    stopListIds: campaign.stopLists?.map((s) => s.uniqueId.toString()) ?? [],
  });

  const [, setLoadingCount] = useState(
    () => Math.floor(Math.random() * 9000) + 1000,
  );

  useEffect(() => {
    if (!isCountsLoading) return;

    const interval = setInterval(() => {
      setLoadingCount(Math.floor(Math.random() * 9000) + 1000);
    }, 100);

    return () => clearInterval(interval);
  }, [isCountsLoading]);

  return (
    <TargetGroupProvider>
      <div className="flex h-full flex-col justify-between">
        {/* <div className="mx-auto flex max-w-xs items-center justify-center">
        <Steps steps={steps} onStepClick={goToStep} />
      </div> */}
        <Outlet />
      </div>
      <TargetGroupSidebar
        configurations={stepper.context.configurations}
        stopLists={stepper.context.stopLists}
        onStopListClick={() =>
          navigate({
            to: "/campaigns/setup/define/stop-lists",
          })
        }
        onFilterGroupSelect={(filterGroupId, category) => {
          navigate({
            to: "/campaigns/setup/define/$category/$filter",
            params: {
              filter: filterGroupId,
              category,
            },
          });
        }}
      />
    </TargetGroupProvider>
  );
}
